<div
  class="list-container"
  infiniteScroll
  [infiniteScrollDistance]="infiniteScrollDistance"
  [scrollWindow]="false"
  [infiniteScrollContainer]="containerRef"
  [infiniteScrollThrottle]="500"
  [fromRoot]="true"
  (scrolled)="loadMore()"
>
  @for (activity of notifications; track trackByActivity($index, activity)) {
    <rt-dropdown-item (click)="$event.preventDefault()">
      <rt-activity-item
        [activity]="activity"
        [canManageCandidates]="canManageCandidates"
        [isSmall]="true"
        (activityItemClick)="onActivityItemClick(activity)"
        (readUnreadClick)="onMarkReadUnread($event)"
      >
      </rt-activity-item>
    </rt-dropdown-item>
  }
</div>
@if (loading) {
  <rt-dropdown-item layout-centered>
    <rt-spinner padding-tb></rt-spinner>
  </rt-dropdown-item>
}

@if (notifications.length === 0 && loaded) {
  <rt-dropdown-item [hasHoverEffect]="false">
    <div layout layout-full-width layout-justify-center>
      <rt-empty-state
        [icon]="'notifications-active'"
        [desc]="'app.notifications.empty_state.description' | translate"
        space
      >
        <a rt-button href="#/settings/notifications" variant="outline">
          {{ 'app.notifications.empty_state.button' | translate }}
        </a>
      </rt-empty-state>
    </div>
  </rt-dropdown-item>
}
